<div class="p-4">
    
    <div class="ml-auto text-right">
        <app-bantuan-isi-manajemen></app-bantuan-isi-manajemen>
    </div>
    <div class="d-flex align-items-left align-items-md-center flex-column flex-md-row  pt-2 pb-4">
        <div>
            <h3 class="fw-bold mb-3"*ngIf="userData">Hi, {{userData?.data_user?.username ?? "User"}}</h3>
            <h6 class="op-7 mb-2">Selamat Datang di Dashboard CRM</h6>
        </div>
    </div>
    <div class="row margin-block-end">
        <div class="col-md-6 col-lg-3">
            <div class="card card-stats card-round">
                <div class="card-body">
                    <div class="row align-items-center flex-nowrap">
                        <div class="col-icon">
                            <div class="icon-big text-center icon-primary bubble-shadow-small">
                                <i class="fas fa-users"></i>
                            </div>
                        </div>
                        <div class="col-stats ms-3 ms-sm-0">
                            <div class="numbers">
                                <p class="card-category">Nasabah Terdaftar</p>
                                <h4 class="card-title">9,294</h4>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-md-6 col-lg-3">
            <div class="card card-stats card-round">
                <div class="card-body">
                    <div class="row align-items-center flex-nowrap">
                        <div class="col-icon">
                            <div class="icon-big text-center icon-info bubble-shadow-small">
                                <i class="fas fa-user-check"></i>
                            </div>
                        </div>
                        <div class="col-stats ms-3 ms-sm-0">
                            <div class="numbers">
                                <p class="card-category">Supplier Aktif</p>
                                <h4 class="card-title">879</h4>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-md-6 col-lg-3">
            <div class="card card-stats card-round">
                <div class="card-body">
                    <div class="row align-items-center flex-nowrap">
                        <div class="col-icon">
                            <div class="icon-big text-center icon-success bubble-shadow-small">
                                <i class="fas fa-luggage-cart"></i>
                            </div>
                        </div>
                        <div class="col-stats ms-3 ms-sm-0">
                            <div class="numbers">
                                <p class="card-category">Pengiriman Makanan</p>
                                <h4 class="card-title">1,299</h4>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-md-6 col-lg-3">
            <div class="card card-stats card-round">
                <div class="card-body">
                    <div class="row align-items-center flex-nowrap">
                        <div class="col-icon">
                            <div class="icon-big text-center icon-secondary bubble-shadow-small">
                                <i class="far fa-check-circle"></i>
                            </div>
                        </div>
                        <div class="col-stats ms-3 ms-sm-0">
                            <div class="numbers">
                                <p class="card-category">Makanan Terkirim</p>
                                <h4 class="card-title">576</h4>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

<!--     <div class="card card-body mb-3">
        <app-peta-distribusi-and-charts></app-peta-distribusi-and-charts>
    </div> -->

<!--     <div class="row">
        <div class="col-12 h-100 list-container order-2 order-md-1 scroll-primary" [ngClass]="[mapVisible? 'col-md-8' : 'col-md-12']">
            <app-dashboard-charts [mapVisible]="mapVisible"></app-dashboard-charts>
        </div>
    </div> -->
    
 <!--    <section id="supporter-section">
        <div class="container" >
            <app-supported-by-carousel [paddingVertical]="'py-0'"></app-supported-by-carousel>
        </div>
    </section> -->
</div>